export const institutos = {
  'undefined': '',
  '0': 'Itbm',
  '1': '墨西哥',
  '2': '中美洲和加勒比',
  '3': '中國與大中華',
  '4': '新加坡',
  '5': '火雞',
  '6': '菲律賓',
  '7': '厄瓜多爾',
  '8': 'izzi',
  '9': '羅馬尼亞',
  '10':'公司人力資源',
  '16': 'Itbm',
  '17': '一項調查',
}


export const sectores = {
  "1":{
     "NOMBRE":"2.0 航空航天",
     "SUBSECTORES":{
        "1":"2.1 航空航天 // 其他 / 不適用"
     }
  },
  "2":{
     "NOMBRE":"4.0 農業",
     "SUBSECTORES":{
        "1":"4.1 農業 // 其他 / 不適用 "
     }
  },
  "3":{
     "NOMBRE":"5.0 生物技術和製藥",
     "SUBSECTORES":{
        "1":"5.1 生物技術與製藥 // 生物技術",
        "2":"5.2 生物技術與製藥 // 製藥",
        "3":"5.3 生物技術和製藥 // 其他"
     }
  },
  "4":{
     "NOMBRE":"6.0 建設",
     "SUBSECTORES":{
        "1":"（舊）建築 // 承包",
        "2":"（舊）建築 // 基礎設施",
        "3":"6.1 施工 // 其他 / 不適用"
     }
  },
  "5":{
     "NOMBRE":"12.0 醫療保健",
     "SUBSECTORES":{
        "1":"(OLD) 醫療保健 // 住院護理服務",
        "2":"12.1 醫療保健 // 醫院",
        "3":"12.2 醫療保健 // 醫療用品的銷售或分銷",
        "4":"12.3 醫療保健 // 專科",
        "5":"(舊) 老年服務 // 家庭護理",
        "6":"(OLD) 老齡化服務 // 住房和老年人護理",
        "7":"(OLD) 醫療 // 其他專業服務",
        "8":"12.4 醫療保健 // 服務",
        "9":"12.5 醫療保健 // 其他",
     }
  },
  "6":{
     "NOMBRE":"7.0 教育培訓",
     "SUBSECTORES":{
        "1":"7.1 教育和培訓 // 其他 / 不適用"
     }
  },
  "7":{
     "NOMBRE":"13.0 款待",
     "SUBSECTORES":{
        "3":"13.1 款待 // 餐飲服務",
        "2":"13.2 款待 // 酒店/度假村",
        "1":"13.3 款待 // 行政",
        "4":"13.4 款待 // 其他"
     }
  },
  "8":{
     "NOMBRE":"16.0 製造和生產",
     "SUBSECTORES":{
        "28":"16.1 製造和生產 // 替代能源",
        "1":"16.2 製造和生產 // 汽車",
        "15":"16.3 製造和生產 // 基礎金屬和金屬製品",
        "14":"16.4 製造和生產 // 建築材料",
        "24":"16.5 製造和生產 // 化學品",
        "3":"16.6 製造和生產 // 焦炭、石油衍生物和核燃料",
        "8":"16.7 製造和生產 // 電氣、電子和光學設備",
        "6":"16.8 製造和生產 // 電子",
        "7":"16.9 製造和生產 // 能源",
        "5":"16.10 製造和生產 // 能源分配",
        "20":"16.11 製造和生產 // 食品：乳製品和家禽產品",
        "21":"16.12 製造和生產 // 食品：煙草",
        "19":"16.13 製造和生產 // 食品：飲料",
        "18":"16.14 製造和生產 // 食品：其他",
        "16":"16.15 製造和生產 // 家具",
        "10":"16.16 製造和生產 // 汽油/零售",
        "31":"16.17 製造和生產 // 醫療保健",
        "17":"16.18 製造和生產 // 皮革和皮革製品",
        "13":"16.19 製造和生產 // 機械和設備",
        "11":"16.20 製造和生產 // 醫療器械",
        "22":"16.21 製造和生產 // 非金屬礦物",
        "2":"16.22 製造和生產 // 個人和家庭護理產品",
        "23":"16.23 製造和生產 // 紙漿、紙張和紙張衍生物",
        "4":"16.24 製造生產//橡塑製品",
        "25":"16.25 製造和生產 // 安全",
        "26":"16.26 製造和生產 // 紡織品和紡織產品",
        "30":"16.27 製造和生產 // 運輸設備",
        "29":"16.28 製造和生產 // 供水和處理",
        "12":"16.29 製造和生產 // 木材和木材衍生物",
        "32":"16.30 製造和生產 // 其他",
        "27":"(OLD) 製造和生產 // 快速消費品",
        "9":"（舊）製造和生產 // 醫療保健",
     }
  },
  "9":{
     "NOMBRE":"17.0 媒體",
     "SUBSECTORES":{
        "1":"17.1 媒體 // 出版商和印刷商",
        "4":"17.2 媒體 // 電視/電影/視頻",
        "2":"17.3 媒體 // 廣播",
        "3":"17.4 媒體 // 互聯網服務",
        "5":"17.5 媒體 // 其他",
     }
  },
  "10":{
     "NOMBRE":"18.0 採礦和採石場",
     "SUBSECTORES":{
        "1":"18.1 礦山和採石場 // 其他 / 不適用"
     }
  },
  "11":{
     "NOMBRE":"(OLD) 非營利和慈善組織",
     "SUBSECTORES":{
        "1":"-"
     }
  },
  "12":{
     "NOMBRE":"21.0 零售貿易",
     "SUBSECTORES":{
        "4":"21.1 零售貿易 // 服裝/紡織品/鞋類",
        "2":"21.2 零售貿易 // 計算機/電子產品",
        "1":"21.3 零售貿易 // 食品/倉庫",
        "5":"21.4 零售貿易 // 電子商務",
        "3":"21.5 零售貿易 // 特色產品",
        "6":"21.6 零售貿易 // 其他",
     }
  },
  "13":{
     "NOMBRE":"11.0 金融服務和保險",
     "SUBSECTORES":{
        "1":"11.1 金融服務和保險 // 投資",
        "9":"11.2 金融服務和保險 // 會計",
        "8":"11.3 金融和保險服務 // 銀行/信貸服務",
        "5":"11.4 金融服務和保險 // 健康保險",
        "7":"11.5 金融服務和保險 // 一般保險",
        "6":"11.6 金融服務和保險 // 人壽保險",
        "3":"11.7 金融服務和保險 // 汽車保險",
        "4":"11.8 金融服務和保險 // 家庭保險",
        "2":"11.9 金融服務和保險 // 再保險",
        "10":"11.10 金融服務和保險 // 其他",
     }
  },
  "14":{
    "NOMBRE":"14.0 工業服務",
    "SUBSECTORES":{
      "3":"14.1 工業服務 // 車輛維修和保養",
      "2":"14.2 工業服務 // 工業設計",
      "1":"14.3 工業服務 // 廢物/垃圾/回收管理",
      "4":"14.4 工業服務 // 其他",
    }
  },
  "15":{
     "NOMBRE":"19.0 專業服務",
     "SUBSECTORES":{
        "14":"19.1 專業服務 // 廣告和營銷",
        "2":"19.2 專業服務 // 建築/設計",
        "5":"19.3 專業服務 // 諮詢 - 管理",
        "7":"19.4 專業服務 // 工程諮詢",
        "4":"19.5 專業服務 // 環境諮詢",
        "8":"19.6 專業服務 // 製造諮詢",
        "3":"19.7 專業服務 // 風險評估/精算諮詢",
        "11":"19.8 專業服務 // 法律諮詢",
        "16":"19.9 專業服務 // 安全",
        "15":"19.10 專業服務 // 人員招聘",
        "6":"19.11 專業服務 // 電話支持 / 銷售中心",
        "1":"19.12 專業服務 // 差旅管理",
        "19":"19.13 專業服務 // 其他",
        "12":"(OLD) 專業服務 // 業務流程外包",
        "13":"(OLD) 專業服務 // 業務流程外包 / 呼叫中心",
        "9":"(OLD) 專業服務 // 會計、簿記和審計",
        "17":"(OLD) 專業服務 // 廣告營銷 / 廣告",
        "18":"(OLD) 專業服務 // 廣告和營銷 / 直銷",
        "10":"(OLD) 專業服務 // 教育和培訓"
     }
  },
  "16":{
     "NOMBRE":"22.0 社會服務和政府機構",
     "SUBSECTORES":{
        "3":"22.1 社會服務和政府機構 // 商業服務",
        "1":"22.2 社會服務和政府機構 // 文化和藝術",
        "2":"22.3 社會服務和政府機構 // 教育",
        "6":"22.4 社會服務和政府機構……一般公共行政活動",
        "5":"22.5 社會服務和政府機構 // 住房",
        "4":"22.6 社會服務和政府機構 // 人類健康和社會工作",
        "7":"22.7 社會服務和政府機構 // 住宅護理",
        "8":"22.8 社會服務和政府機構 // 其他",
     }
  },
  "17":{
     "NOMBRE":"15.0 信息技術",
     "SUBSECTORES":{
        "3":"15.1 信息技術 // 硬件",
        "4":"15.2 信息技術 // 互聯網服務提供商",
        "5":"15.3 信息技術 // 軟件",
        "6":"15.4 信息技術 // 互聯網服務",
        "1":"15.5 信息技術 // IT 諮詢",
        "2":"15.6 信息技術 // 數據存儲/管理",
        "7":"15.7 信息技術 // 其他",
     }
  },
  "18":{
     "NOMBRE":"24.0 交通",
     "SUBSECTORES":{
        "2":"24.1 運輸 // 航空公司 / 商業航空",
        "1":"24.2 運輸 // 包裹運輸",
        "3":"24.3 運輸 // 陸路和海路旅客運輸",
        "4":"24.4 運輸 // 運輸和儲存",
        "5":"24.5 運輸 // 其他",
     }
  },
  "19":{
     "NOMBRE":"23.0 電信",
     "SUBSECTORES":{
        "1":"23.1 電信 // 其他 / 不適用"
     }
  },
  "20":{
     "NOMBRE":"8.0 電子產品",
     "SUBSECTORES":{
        "1":"8.1 電子產品 // 其他 / 不適用"
     }
  },
  "21":{
     "NOMBRE":"9.0 工程",
     "SUBSECTORES":{
        "1":"9.1 工程 // 其他 / 不適用"
     }
  },
  "22":{
     "NOMBRE":"10.0 娛樂",
     "SUBSECTORES":{
        "3":"10.1 娛樂 // 表演藝術和觀眾體育",
        "2":"10.2 娛樂 // 博物館",
        "1":"10.3 娛樂 // 樂趣和機會遊戲",
        "4":"10.4 娛樂 // 其他",
     }
  },
  "23":{
     "NOMBRE":"20.0 房地產",
     "SUBSECTORES":{
        "1":"20.1 房地產 // 住房",
        "2":"20.2 房地產 // 物業管理",
        "3":"20.3 房地產 // 其他",
     }
  },
  "24":{
     "NOMBRE":"25.0 其他",
     "SUBSECTORES":{
        "1":"25.1 其他/不適用"
     }
  },
  "25": {
    "NOMBRE":"3.0 長者服務",
    "SUBSECTORES": {
      "1":"3.1 養老服務 // 住房和養老",
      "2":"3.2 長者服務 // 居家護理",
      "3":"3.3 老年人服務 // 其他",
    }
  }
}

export const ranking = {
  '1': {
    'NOMBRE': '是啊',
    'TIPO': {
      '1': '小於50',
      '2': '50至500名跨國公司',
      '3': '50至500家跨國公司',
      '4': '大（500至4999)',
      '5': '5000以上'
      // '6': '公共部門',
      // '7': '不參加排名',
      // '8': 'Culture Audit'
    }
  },
  '2': {
    'NOMBRE': '沒有啦',
    'TIPO': {
      '1': '小於50',
      '2': '50至500名跨國公司',
      '3': '50至500家跨國公司',
      '4': '大（500至4999)',
      '5': '5000以上'
    }
  },
  'Nacional': '國家的',
  'Multinacional': '跨國'
}

export const productos = {
  '1': '證明',
  '2': '測量',
  '3': '035號',
  '4': '脈衝檢查',
  '5': '記錄員NOM-035',
  '6': '重點地區',
  '7': '文件管理器',
  '8': '文化審核',
  '9': '文化審核v2',
  '10': '文化審核培訓',
  '11': '增強測量',
  '12': '測量+ MST',
  '13': '按區域測量',
  '14': '領導測量',
  '15': '按尺寸測量',
  '16': '認證措施',
  '17': '結果',
  '19': '更好NOM-035',
  '20': '認證v2.0',
  '21': '全球結果',
  '22': '4ALL實踐單結果',
  '23': '完成結果',
  '24': '銀包',
  '25': '金包',
  '26': '白金包',
  '37':'文化審核SP',
  '40': '認證v3.0',
  '41': '測量v3.0',
  '42': '脈衝檢查v3.0',
  '43': '焦點區域v3.0',
  '50': '文化審計 5.0',
  '51': '4ALL 文化評估',
  'CULTUREGOEXPRESS':'Cultural Go Express',
  '53':'領袖GO',
  '54':'Action GO',
  '56': 'AMCO',
  '57': '體面的工作',
  '58':'第一份工作',
  'ENCUESTA':'附加認證',
  '60':'認證（進口）',
  '61':'文化簡報',
  '62':'文化審核',
  '63': 'NOM-035 v3.0',
  '64':'SP 2022',
  '65':'文化審計 GoFlow 2 2022',
  '66':'文化審核標準 1',
  '67':'文化審計® CA&C',
  '69': '證明銀牌',
  '70':'GoFlow 結果',
  '71':'文化審核（認證）2022',
   '72':'文化審計（認證, rkg.） 2022',
   '73':'文化審計（認證, rkg. y adic.） 2022',
   '68':'Swift',
   '76':'文化審計（認證,,rkg. y adic.) 2024',
   '77': '文化簡報（認證）2024',
   '78':'文化審計（認證和排名）2024',
}
export const productosTurquia = {
  '1': '證明',
  '2': '測量',
  '3': '035號',
  '4': '脈衝檢查',
  '5': '記錄員NOM-035',
  '6': '重點地區',
  '7': '文件管理器',
  '8': '文化審核',
  '9': '文化簡介和文化審核5.0',
  '10': '文化審核培訓',
  '11': '增強測量',
  '12': '測量+ MST',
  '13': '按區域測量',
  '14': '領導測量',
  '15': '按尺寸測量',
  '16': '認證措施',
  '17': '結果',
  '19': '更好NOM-035',
  '20': '認證v2.0',
  '21': '全球結果',
  '22': '4ALL實踐單結果',
  '23': '完成結果',
  '24': '銀包',
  '25': '金包',
  '26': '白金包',
  '28': '文化簡介5.0',
  '29': '文化審核5.0',
  '34': '結果5.0版本3.1',
  '35': '結果5.0版本3.2',
  '36': '結果5.0版本3.3',
  '38': '文化審核行動計劃',
  '40': '認證v3.0',
  '41': '測量v3.0',
  '42': '脈衝檢查v3.0',
  '43': '焦點區域v3.0',
  '60':'認證（進口）',
  '54':'Action GO',
  '74':'厄澤爾·李斯特',
}

export const categorias = {
  'Certify': '認證產品',
  'Measure': '測量產品',
  'Norm 35': 'NOM-035產品',
  'Pulse Check': '脈衝檢查產品',
  'Focus Area': '重點領域產品',
  'Drive': '文件管理器',
  'Culture Audit': '文化審核產品',
  'Resultados': '結果的產品',
  'Resultados 4 ALL': '4ALL產品',
  'Resultados 5.0': '結果5.0產品',
  'Culture Audit Action Plan':'行動計劃',
  'Leader GO':'領袖GO',
  'Action GO':'Action GO',
  'Certify Amco':'附加認證',
  'PRODUCTOS_ICCA':'ICCA products',
  'Resultados V2 HK':'認證（進口）',
  'Swift':'Swift',

}

export const niveles = {
  '1': '公司',
  '2': '管理員',
  '3': '一世Ť乙中號',
  '4': '結果',
  '5': '細分結果',
  '8': '文化審核產品',
  '9':'結果 5.0',
  '11':'伊齊',
  '12': 'ActionGo',
  '13': '細分結果和ActionGo',
  '14': 'ActionGo負責人',
  '15': '用戶行動領先者',
  '17': '斯威夫特批發商',
  '18': '網絡公司簡介',
  '19': '結果 2.0',
}

export const regiones = {
  '1': '加勒比海',
  '2': '中美洲',
  '3': '中美洲和加勒比',
  '4': '八角地區',
  '5': '中央區域',
  '6': '中西部地區',
  '7': '中南部地區',
  '8': '東北地區',
  '9': '西北地區',
  '10': '東南地區',
  '11':'香港',
  '12':'台灣',
  '13':'中國大陸',
  '14':'大中華',
  '15':'土耳其',
}

export const plantillas = {
  '5d826095d06d596a84de6315': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5dcb61e940fb582bc44adf49': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5dcc946633e1ff000870107e': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5dcdd9fd33e1ff1aacf6f04f': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5ddc3fa4f323d727d09870ad': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5de58de640fb582e0c18d730': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5de69aa4a943da3efc4d0fa6': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
  },

  '5de9498fa943da3efc4d0fa8': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5df820df65e4986b14d1f71c': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  '5dfc26cec8800d5188a18875': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e166105d06d595eb04dca00': {
    'NOMBRE':'Focus_Estandar'
  },

  '5e1754a5f323d72aac6d8726': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e17930b65e4983a3016a4ed': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e2100c6f323d721045812c5': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e21042ff323d721045812c6': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e210575f323d721045812c7': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e2b6dbdc8800d52f45fc248': {
    'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
  },

  '5e2f72c8c8800d3398c463a4': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e3c59b5b473cb6d3e40f902': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e697232b473cb6d3e84d87d': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5e6972f3b473cb6d3e84e1e0': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
  },

  '5e697302b473cb6d3e84e2a3': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
  },

  '5e697311b473cb6d3e84e364': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
  },

  '5e697329b473cb6d3e84e490': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
  },

  '5e69734fb473cb6d3e84e656': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
  },

  '5e697367b473cb6d3e84e791': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
  },

  '5e738efbb473cb6d3e8c3915': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },

  '5e86487eb473cb6d3e09cc42': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5e864896b473cb6d3e09cde1': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  //PLANTILLAS DE CERTIFICAR 2.0
    '5e960018b473cb6d3ec5f935': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
    },

    '5e96007cb473cb6d3ec60098': {
      'NOMBRE':'TR_ESTANDAR'
    },

    '5e9600a6b473cb6d3ec603c7': {
      'NOMBRE':'04_ENGLISH_JAPAN'
    },

    '5e9600f0b473cb6d3ec6095a': {
      'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
    },

    '5e960116b473cb6d3ec60c2f': {
      'NOMBRE':'05_ING_ESTANDAR'
    },

    '5e96039fb473cb6d3ec64310': {
      'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
    },

    '5e9603d7b473cb6d3ec6485e': {
      'NOMBRE':'TR TI + EVP + GPTW LEADER'
    },

    '5e9604f7b473cb6d3ec66540': {
      'NOMBRE':'TR TI + EVP'
    },

    '5e960525b473cb6d3ec66a3f': {
      'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
    },

    '5e960549b473cb6d3ec66e30': {
      'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
    },

    '5e96056ab473cb6d3ec671f1': {
      'NOMBRE':'04_ESP_GOBIERNO'
    },

    '5e9605b5b473cb6d3ec67a55': {
      'NOMBRE':'CAYC_GOBIERNO'
    },

    '5e9605e0b473cb6d3ec67f3c': {
      'NOMBRE':'ING_RUMANO_ESTANDAR'
    },

    '5e96060fb473cb6d3ec684d8': {
      'NOMBRE':'ESP_CAYC_Diversidad'
    },
    '5f84a2fab473cb6d3e017c0d': {
      'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
    },
    '5f733fcab473cb6d3e19d56c': {
      'NOMBRE':'04_ESP_Gobierno_MX'
    },
    // pendiente TK
    '5e14fc2cf323d72aac6d8722': {
      'NOMBRE':' '
    },
    // pendiente TK
    '5e14fcc4f323d72aac6d8723': {
      'NOMBRE':' '
    },
    // pendiente MX
    '5d71b21db11f333a30de813e': {
      'NOMBRE':' '
    },
    '5fcebf59c1057065a70fe712':{
      'NOMBRE':'TR_ESTANDAR_+COVID v2'
    },
    '6046a10e7308ab51607f95b5':{
      'NOMBRE':''
    }
}

export const answer = {
  '1': '文化圍棋調查',
  '2': '紙',
  '3': '短信',
  '4': '亭',
  '5': '不適用',
}
